// extracted by mini-css-extract-plugin
var _1 = "#007ac9";
var _2 = "#575757";
var _3 = "1.5rem";
var _4 = "#dedede";
var _5 = "#adf";
var _6 = "1rem";
var _7 = "#bebebe";
var _8 = "nodeMarkerCrossroad-SBEC";
var _9 = "nodeMarkerMunicipality-w1TW";
var _a = "nodeMarkerStop-sSOz";
var _b = ".8rem";
var _c = "#fc383a";
var _d = "#c40608";
var _e = "#000";
var _f = "usageCount-FCpU";
var _10 = "#0dce0a";
var _11 = "#048c01";
export { _1 as "busBlue", _2 as "darkGrey", _3 as "extraLargeFontSize", _4 as "lightGrey", _5 as "lightblue", _6 as "mediumFontSize", _7 as "mediumLightGrey", _8 as "nodeMarkerCrossroad", _9 as "nodeMarkerMunicipality", _a as "nodeMarkerStop", _b as "smallFontSize", _c as "unusedNeighborColor", _d as "unusedNeighborColorHighlight", _e as "unusedNodeColor", _f as "usageCount", _10 as "usedNeighborColor", _11 as "usedNeighborColorHighlight" }
